import React, { FC } from 'react'
import styled from 'styled-components'


export const ArrowDownAbsoluteContainer = styled.div`
  border-radius: 1.15rem;
  position: absolute;
  bottom: -1.25rem;
  left: 50%;
  background-color: ${ ( { theme } ) => theme.arrowDownAbsoluteContainerBackgroundColor};
  border: 2px solid ${ ( { theme } ) => theme.arrowDownAbsoluteContainerBorderColor};
  padding: 0.1rem 0.5rem 0rem 0.5rem;
`
